angular
    .module('annexaApp')
    .component('annexaBoxPublishAudit',{
        templateUrl: './components/doc/annexa-box-publish-audit/annexa-box-publish-audit.html',
        controller:['Language', '$rootScope', 'AnnexaObjectBoxFactory', 'GlobalDataFactory', '$filter', '$scope', '$state', 
        function(Language, $rootScope, AnnexaObjectBoxFactory, GlobalDataFactory, $filter, $scope, $state) {
            var vm = this;
            vm.languageColumn = Language.getActiveColumn();
            
        	this.$onInit = function () {
            	if(!vm.boxTitle) {
                    vm.boxTitle = 'global.documents.auditBoxPublishTitle';
                }
            	vm.emptyText = 'global.documents.auditBoxPublishEmpty';
            	if(vm.content && vm.content.length > 0){
            		_.forEach(vm.content, function(audit){
            			var auditAction = $linq(GlobalDataFactory.publishAuditActions).firstOrDefault({language1:audit.action, language2:audit.action,languge3:audit.action},"x=> x.id == '"+audit.action+"'");
            			audit.actionLiteral = auditAction[vm.languageColumn];
            			audit.actionDate = ((audit.actionDate)?$filter('date')(new Date(audit.actionDate), 'dd/MM/yyyy HH:mm:ss'):'');
            		});
            	}
            }
        }],
        bindings: {
            boxTitle: '@?',
            content: '=',
            show:'='
        }
    })